<template>
    <div class="repair-process" v-if="job && canViewJob">

        <div class="alert alert-danger alert-centered cursor-pointer rounded-0 mb-0" v-if="soWarrantyErrors.length > 0" @click="showSoWarrantyErrorModal">
            <animated-error></animated-error> {{ soWarrantyErrors.length }} errors on GSPN. Tap here to view
        </div>

        <!-- Progress Bar -->
        <progress-steps :deviceStatus="deviceStatus"></progress-steps> <!-- TODO: Hide on the repair complete page for technicians -->

        <!-- Content -->
        <transition
                name="fade"
                mode="out-in">
            <router-view></router-view>
        </transition>

        <!-- Device Status Modal -->
        <update-device-status-modal v-if="job && deviceId" :deviceId="deviceId" :jobId="jobId"></update-device-status-modal>

        <!-- Note Modal -->
        <note-modal v-if="job && deviceId" :jobId="jobId" :noteableId="deviceId" :noteableType="'device'" ></note-modal>

        <!-- SO Warranty Error Modal -->
        <so-warranty-error-modal :soWarrantyErrors="soWarrantyErrors"></so-warranty-error-modal>

    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        props:['deviceId','jobId'],

        data() {
            return {
                canViewJob: true,
            }
        },

        mounted() {
            this.fetchJobData();
        },

        watch: {
            jobId(jobId) {
                if (jobId) {
                    this.fetchJobData();
                }
            }
        },

        computed: {
            ...mapGetters([
                "device",
                "deviceStatus",
                "isSuperAdmin",
                "isTechnician",
                "job",
                "jobNotes",
                "soWarrantyErrors",
                "user"
            ]),
        },

        methods: {
            ...mapActions([
                "loadJob",
                "loadDeviceForJob",
                "loadDeviceStatus",
                "loadJobNotes",
                "loadSoWarrantyErrors"
            ]),

            /** Fetch the order id and devices */
            fetchJobData() {
                this.loadJob({
                    jobId: this.jobId
                }).then(() => {
                    this.loadDeviceForJob({
                        jobId: this.jobId,
                        deviceId: this.deviceId,
                    }).then(() => {
                        this.userCanViewJob();
                        this.loadDeviceStatus({
                            statusId: this.device.status_id
                        });
                        this.loadSoWarrantyErrors({
                            jobId: this.jobId,
                            deviceId: this.deviceId,
                        });
                    });
                });
            },

            /** Show the GSPN errors modal */
            showSoWarrantyErrorModal() {
                this.$bvModal.show('so-warranty-error-modal');
            },

            /** Check if the user can view the job */
            userCanViewJob() {
                if (this.isTechnician && this.user.technician.id !== this.job.technician_id) {
                    return this.canViewJob = false;
                }


                return this.canViewJob = true;
            },
        }
    }
</script>

<style scoped>

</style>